/* eslint-disable */
import * as BABYLON from 'babylonjs';
import { _Exporter, _BinaryWriter, _GLTFUtilities } from 'babylonjs-serializers';
import { DEEPCOPY_IGNORE_SYMBOLS } from './babylonPolyfillConstants.js';
import '../globalImports.js';
import CoreUtils from 'shared/libraries/mwc/utils/coreUtils';

var funcHashXYZ = (x, y, z) => {
    return `${x},${y},${z}`;
    // The algorithm below produces incorrect results some of the time:

    x = x >= 0 ? 2 * x : -2 * x - 1;
    y = y >= 0 ? 2 * y : -2 * y - 1;
    z = z >= 0 ? 2 * z : -2 * z - 1;

    let max = Math.max(x, y, z);
    let hash = max*max*max + (2 * max * z) + z;
    if (max == z)
        hash += Math.max(x, y)*Math.max(x, y);
    if (y >= x)
        hash += x + y;
    else
        hash += y;
    return hash;
};

export default function fillMissingBJSFunctions()
{
    patchMeshIntersection();
    patchGLTFExporter();

    var cloneValue = function (source, destinationObject) {
        if (!source)
            return null;

        if(source.getClassName && source.getClassName() === "Mesh")
            return null;

        if(source.getClassName && source.getClassName() === "SubMesh")
            return source.clone(destinationObject);       
        else if(source.clone)
            return source.clone();

        return null;
    };

    // Changes: performance, readability
    if(BABYLON.DeepCopier && BABYLON.DeepCopier.DeepCopy)
    BABYLON.DeepCopier.DeepCopy = function (source, destination, doNotCopyList, mustCopyList) {
        let obj = source;
        let sourceValue;
        let typeOfSourceValue;
        let mapOfProps = {};
        do {
            let propertyNames = Object.getOwnPropertyNames(obj);

            for(let prop of propertyNames)
            {
                if(DEEPCOPY_IGNORE_SYMBOLS.has(prop))
                    continue;

                if(prop[0] === "_" && (!mustCopyList || mustCopyList.indexOf(prop) === -1))
                    continue;

                if(mapOfProps[prop])
                    continue;

                mapOfProps[prop] = true;

                if(BABYLON.StringTools.EndsWith(prop, "Observable"))
                    continue;

                if(doNotCopyList && doNotCopyList.indexOf(prop) !== -1)
                    continue;

                sourceValue = source[prop];
                typeOfSourceValue = typeof sourceValue;
                if(typeOfSourceValue === "function")
                    continue;

                try
                {
                    if(typeOfSourceValue !== "object") 
                    {
                        destination[prop] = sourceValue;
                        continue;
                    }

                    if(!(sourceValue instanceof Array)) 
                    {
                        destination[prop] = cloneValue(sourceValue, destination);
                        continue;
                    }

                    // Object that is not an array
                    destination[prop] = [];
                    if(sourceValue.length > 0) 
                    {
                        if(typeof sourceValue[0] == "object")
                        {
                            for(let index = 0; index < sourceValue.length; index++)
                            {
                                let clonedValue = cloneValue(sourceValue[index], destination);
                                // Test if auto inject was not done
                                if(destination[prop].indexOf(clonedValue) === -1)
                                    destination[prop].push(clonedValue);
                            }
                        }
                        else
                            destination[prop] = sourceValue.slice(0);
                    }

                }
                catch (e)
                {
                    // Log a warning (it could be because of a read-only property)
                    BABYLON.Logger.Warn(e.message);
                }
            }
        } while (obj = Object.getPrototypeOf(obj));
    };
 
    if(parseFloat(BABYLON.Engine.Version) > 3.0)
    {
    BABYLON.CSG.prototype.buildMeshGeometry = function (name, scene, keepSubMeshes) {
        var matrix = this.matrix.clone();
        matrix.invert();
        var mesh = new BABYLON.Mesh(name, scene);
        var vertices = [];
        var indices = [];
        var normals = [];
        var uvs = null;
        var vertColors = null;
        var vertex = BABYLON.Vector3.Zero();
        var normal = BABYLON.Vector3.Zero();
        var uv = BABYLON.Vector2.Zero();
        var vertColor = new BABYLON.Color4(0, 0, 0, 0);
        var polygons = this._polygons ? this._polygons : this.polygons;
        var polygonIndices = [0, 0, 0];
        var polygon;
        var vertice_dict = new Map();

        var localNormal = BABYLON.Vector3.Zero();
        var localVertex = BABYLON.Vector3.Zero();
        let localVertexKey;

        var vertex_idx;
        var currentIndex = 0;
        var subMeshDict = {};
        var subMeshObj;
        if (keepSubMeshes) {
            // Sort Polygons, since subMeshes are indices range
            polygons.sort(function (a, b) {
                if (a.shared.meshId === b.shared.meshId) {
                    return a.shared.subMeshId - b.shared.subMeshId;
                }
                else {
                    return a.shared.meshId - b.shared.meshId;
                }
            });
        }
        for (var i = 0, il = polygons.length; i < il; i++) {
            polygon = polygons[i];
            // Building SubMeshes
            if (!subMeshDict[polygon.shared.meshId]) {
                subMeshDict[polygon.shared.meshId] = {};
            }
            if (!subMeshDict[polygon.shared.meshId][polygon.shared.subMeshId]) {
                subMeshDict[polygon.shared.meshId][polygon.shared.subMeshId] = {
                    indexStart: +Infinity,
                    indexEnd: -Infinity,
                    materialIndex: polygon.shared.materialIndex,
                };
            }
            subMeshObj = subMeshDict[polygon.shared.meshId][polygon.shared.subMeshId];
            for (var j = 2, jl = polygon.vertices.length; j < jl; j++) {
                polygonIndices[0] = 0;
                polygonIndices[1] = j - 1;
                polygonIndices[2] = j;
                for (var k = 0; k < 3; k++) {
                    vertex.copyFrom(polygon.vertices[polygonIndices[k]].pos);
                    normal.copyFrom(polygon.vertices[polygonIndices[k]].normal);
                    if (polygon.vertices[polygonIndices[k]].uv) {
                        if (!uvs) {
                            uvs = [];
                        }
                        uv.copyFrom(polygon.vertices[polygonIndices[k]].uv);
                    }
                    if (polygon.vertices[polygonIndices[k]].vertColor) {
                        if (!vertColors) {
                            vertColors = [];
                        }
                        vertColor.copyFrom(polygon.vertices[polygonIndices[k]].vertColor);
                    }
                    BABYLON.Vector3.TransformCoordinatesToRef(vertex, matrix, localVertex);
                    BABYLON.Vector3.TransformNormalToRef(normal, matrix, localNormal);

                    //localVertexKey = localVertex.x + "," + localVertex.y + "," + localVertex.z;
                    localVertexKey = funcHashXYZ(localVertex.x, localVertex.y, localVertex.z);
                    vertex_idx = vertice_dict.get(localVertexKey);

                    var areUvsDifferent = false;
                    if (uvs && !(uvs[vertex_idx * 2] === uv.x || uvs[vertex_idx * 2 + 1] === uv.y)) {
                        areUvsDifferent = true;
                    }
                    var areColorsDifferent = false;
                    if (vertColors &&
                        !(vertColors[vertex_idx * 4] === vertColor.r ||
                            vertColors[vertex_idx * 4 + 1] === vertColor.g ||
                            vertColors[vertex_idx * 4 + 2] === vertColor.b ||
                            vertColors[vertex_idx * 4 + 3] === vertColor.a)) {
                        areColorsDifferent = true;
                    }
                    // Check if 2 points can be merged
                    //if (!(typeof vertex_idx !== "undefined" &&
                    if (!(vertex_idx !== undefined &&
                        normals[vertex_idx * 3] === localNormal.x &&
                        normals[vertex_idx * 3 + 1] === localNormal.y &&
                        normals[vertex_idx * 3 + 2] === localNormal.z) ||
                        areUvsDifferent ||
                        areColorsDifferent) {
                        vertices.push(localVertex.x, localVertex.y, localVertex.z);
                        if (uvs) {
                            uvs.push(uv.x, uv.y);
                        }
                        normals.push(normal.x, normal.y, normal.z);
                        if (vertColors) {
                            vertColors.push(vertColor.r, vertColor.g, vertColor.b, vertColor.a);
                        }
                        vertex_idx = vertices.length / 3 - 1;
                        vertice_dict.set(localVertexKey, vertex_idx);
                        //vertex_idx = vertice_dict[localVertexKey] = vertices.length / 3 - 1;
                    }
                    indices.push(vertex_idx);
                    subMeshObj.indexStart = Math.min(currentIndex, subMeshObj.indexStart);
                    subMeshObj.indexEnd = Math.max(currentIndex, subMeshObj.indexEnd);
                    currentIndex++;
                }
            }
        }
        mesh.setVerticesData(BABYLON.VertexBuffer.PositionKind, vertices);
        mesh.setVerticesData(BABYLON.VertexBuffer.NormalKind, normals);
        if (uvs) {
            mesh.setVerticesData(BABYLON.VertexBuffer.UVKind, uvs);
        }
        if (vertColors) {
            mesh.setVerticesData(BABYLON.VertexBuffer.ColorKind, vertColors);
        }
        mesh.setIndices(indices, null);
        if (keepSubMeshes) {
            // We offset the materialIndex by the previous number of materials in the CSG mixed meshes
            var materialIndexOffset = 0, materialMaxIndex = void 0;
            mesh.subMeshes = new Array();
            for (var m in subMeshDict) {
                materialMaxIndex = -1;
                for (var sm in subMeshDict[m]) {
                    subMeshObj = subMeshDict[m][sm];
                    BABYLON.SubMesh.CreateFromIndices(subMeshObj.materialIndex + materialIndexOffset, subMeshObj.indexStart, subMeshObj.indexEnd - subMeshObj.indexStart + 1, mesh);
                    materialMaxIndex = Math.max(subMeshObj.materialIndex, materialMaxIndex);
                }
                materialIndexOffset += ++materialMaxIndex;
            }
        }
        return mesh;
    };
    }

    // Babylon's random guid version is very slow due to using regular expressions.
    BABYLON.Tools.RandomId = CoreUtils.createGuid;

    // Stupidly, instead of deleting material map entries, Babylon sets them to undefined,
    // which keeps increasing the map size forever and causes getBindedMesh() to become
    // slower and slower, since we iterate over all keys there... Sigh...
    BABYLON.AbstractMesh.prototype.oldSetMaterial = BABYLON.AbstractMesh.prototype._setMaterial;
    BABYLON.AbstractMesh.prototype._setMaterial = function (value) {

        let targetMeshMap = null;
        if (this._internalAbstractMeshDataInfo._material && this._internalAbstractMeshDataInfo._material.meshMap)
            targetMeshMap = this._internalAbstractMeshDataInfo._material.meshMap;

        if (this._internalAbstractMeshDataInfo._material === value) {
            return;
        }

        this.oldSetMaterial(value);

        // Remove from material mesh map id needed
        if(targetMeshMap)
            delete targetMeshMap[this.uniqueId];
    };

    BABYLON.AbstractMesh.prototype.oldSetMaterialProperty = Object.getOwnPropertyDescriptor(BABYLON.AbstractMesh.prototype, 'material').set;
    Object.defineProperty(BABYLON.AbstractMesh.prototype, "material", {
        set: function (value) {

            if (this._internalAbstractMeshDataInfo._material === value) {
                return;
            }

            let targetMeshMap = null;
            if (this._internalAbstractMeshDataInfo._material && this._internalAbstractMeshDataInfo._material.meshMap)
                targetMeshMap = this._internalAbstractMeshDataInfo._material.meshMap;

            this.oldSetMaterialProperty(value);

            // Remove from material mesh map id needed
            if(targetMeshMap)
                delete targetMeshMap[this.uniqueId];
        },
        enumerable: true,
        configurable: true
    });

    BABYLON.AbstractMesh.prototype.oldDispose = BABYLON.AbstractMesh.prototype.dispose;
    BABYLON.AbstractMesh.prototype.dispose = function (doNotRecurse, disposeMaterialAndTextures) {
        let targetMeshMap = null;
        if (this._scene.useMaterialMeshMap) {
            // Remove from material mesh map id needed
            if (this._internalAbstractMeshDataInfo._material && this._internalAbstractMeshDataInfo._material.meshMap) {
                targetMeshMap = this._internalAbstractMeshDataInfo._material.meshMap;
            }
        }
        this.oldDispose(doNotRecurse, disposeMaterialAndTextures);
        if(targetMeshMap)
            delete targetMeshMap[this.uniqueId];
    };

    BABYLON.Material.prototype.markDirty = function(forceMaterialDirty = false) {
        if (this.getScene().blockMaterialDirtyMechanism || this._blockDirtyMechanism) {
            return;
        }

        //const meshes = this.getScene().meshes;
        const meshes = this.getBindedMeshes();
        for (const mesh of meshes) {
            if (!mesh.subMeshes) {
                continue;
            }
            for (const subMesh of mesh.subMeshes) {
                if (subMesh.getMaterial(false) !== this) {
                    continue;
                }

                if (!subMesh.effect) {
                    continue;
                }

                subMesh.effect._wasPreviouslyReady = false;
                subMesh.effect._wasPreviouslyUsingInstances = null;
                subMesh.effect._forceRebindOnNextCall = forceMaterialDirty;
            }
        }

        if (forceMaterialDirty) {
            this.markAsDirty(Material.AllDirtyFlag);
        }
    }

    BABYLON.Material.prototype._markAllSubMeshesAsDirty = function(func) {
        if (this.getScene().blockMaterialDirtyMechanism || this._blockDirtyMechanism) {
            return;
        }

        ///const meshes = this.getScene().meshes;
        // This call can potentially use a mesh map, and avoid going through every mesh in the scene.
        const meshes = this.getBindedMeshes();
        for (const mesh of meshes) {
            if (!mesh.subMeshes) {
                continue;
            }
            for (const subMesh of mesh.subMeshes) {
                // We want to skip the submeshes which are not using this material or which have not yet rendered at least once
                if (subMesh.getMaterial(false) !== this) {
                    continue;
                }

                for (const drawWrapper of subMesh._drawWrappers) {
                    if (!drawWrapper || !drawWrapper.defines || !drawWrapper.defines.markAllAsDirty) {
                        continue;
                    }
                    if (this._materialContext === drawWrapper.materialContext) {
                        func(drawWrapper.defines);
                    }
                }
            }
        }
    }

	if(!BABYLON.GUI)
		BABYLON.GUI = {};

	if(!BABYLON.GUI.Matrix2D)
	{
		/** Class used to provide 2D matrix features */
		BABYLON.GUI.Matrix2D = /** @class */ (function () {
			/**
			 * Creates a new matrix
			 * @param m00 defines value for (0, 0)
			 * @param m01 defines value for (0, 1)
			 * @param m10 defines value for (1, 0)
			 * @param m11 defines value for (1, 1)
			 * @param m20 defines value for (2, 0)
			 * @param m21 defines value for (2, 1)
			 */
			function Matrix2D(m00, m01, m10, m11, m20, m21) {
				/** Gets the internal array of 6 floats used to store matrix data */
				this.m = new Float32Array(6);
				this.fromValues(m00, m01, m10, m11, m20, m21);
			}
			/**
			 * Fills the matrix from direct values
			 * @param m00 defines value for (0, 0)
			 * @param m01 defines value for (0, 1)
			 * @param m10 defines value for (1, 0)
			 * @param m11 defines value for (1, 1)
			 * @param m20 defines value for (2, 0)
			 * @param m21 defines value for (2, 1)
			 * @returns the current modified matrix
			 */
			Matrix2D.prototype.fromValues = function (m00, m01, m10, m11, m20, m21) {
				this.m[0] = m00;
				this.m[1] = m01;
				this.m[2] = m10;
				this.m[3] = m11;
				this.m[4] = m20;
				this.m[5] = m21;
				return this;
			};
			/**
			 * Gets matrix determinant
			 * @returns the determinant
			 */
			Matrix2D.prototype.determinant = function () {
				return this.m[0] * this.m[3] - this.m[1] * this.m[2];
			};
			/**
			 * Inverses the matrix and stores it in a target matrix
			 * @param result defines the target matrix
			 * @returns the current matrix
			 */
			Matrix2D.prototype.invertToRef = function (result) {
				var l0 = this.m[0];
				var l1 = this.m[1];
				var l2 = this.m[2];
				var l3 = this.m[3];
				var l4 = this.m[4];
				var l5 = this.m[5];
				var det = this.determinant();
				if (det < core_Maths_math_vector__WEBPACK_IMPORTED_MODULE_1__.Epsilon * core_Maths_math_vector__WEBPACK_IMPORTED_MODULE_1__.Epsilon) {
					result.m[0] = 0;
					result.m[1] = 0;
					result.m[2] = 0;
					result.m[3] = 0;
					result.m[4] = 0;
					result.m[5] = 0;
					return this;
				}
				var detDiv = 1 / det;
				var det4 = l2 * l5 - l3 * l4;
				var det5 = l1 * l4 - l0 * l5;
				result.m[0] = l3 * detDiv;
				result.m[1] = -l1 * detDiv;
				result.m[2] = -l2 * detDiv;
				result.m[3] = l0 * detDiv;
				result.m[4] = det4 * detDiv;
				result.m[5] = det5 * detDiv;
				return this;
			};
			/**
			 * Multiplies the current matrix with another one
			 * @param other defines the second operand
			 * @param result defines the target matrix
			 * @returns the current matrix
			 */
			Matrix2D.prototype.multiplyToRef = function (other, result) {
				var l0 = this.m[0];
				var l1 = this.m[1];
				var l2 = this.m[2];
				var l3 = this.m[3];
				var l4 = this.m[4];
				var l5 = this.m[5];
				var r0 = other.m[0];
				var r1 = other.m[1];
				var r2 = other.m[2];
				var r3 = other.m[3];
				var r4 = other.m[4];
				var r5 = other.m[5];
				result.m[0] = l0 * r0 + l1 * r2;
				result.m[1] = l0 * r1 + l1 * r3;
				result.m[2] = l2 * r0 + l3 * r2;
				result.m[3] = l2 * r1 + l3 * r3;
				result.m[4] = l4 * r0 + l5 * r2 + r4;
				result.m[5] = l4 * r1 + l5 * r3 + r5;
				return this;
			};
			/**
			 * Applies the current matrix to a set of 2 floats and stores the result in a vector2
			 * @param x defines the x coordinate to transform
			 * @param y defines the x coordinate to transform
			 * @param result defines the target vector2
			 * @returns the current matrix
			 */
			Matrix2D.prototype.transformCoordinates = function (x, y, result) {
				result.x = x * this.m[0] + y * this.m[2] + this.m[4];
				result.y = x * this.m[1] + y * this.m[3] + this.m[5];
				return this;
			};
			// Statics
			/**
			 * Creates an identity matrix
			 * @returns a new matrix
			 */
			Matrix2D.Identity = function () {
				return new Matrix2D(1, 0, 0, 1, 0, 0);
			};
			/**
			 * Creates an identity matrix and stores it in a target matrix
			 * @param result defines the target matrix
			 */
			Matrix2D.IdentityToRef = function (result) {
				result.m[0] = 1;
				result.m[1] = 0;
				result.m[2] = 0;
				result.m[3] = 1;
				result.m[4] = 0;
				result.m[5] = 0;
			};
			/**
			 * Creates a translation matrix and stores it in a target matrix
			 * @param x defines the x coordinate of the translation
			 * @param y defines the y coordinate of the translation
			 * @param result defines the target matrix
			 */
			Matrix2D.TranslationToRef = function (x, y, result) {
				result.fromValues(1, 0, 0, 1, x, y);
			};
			/**
			 * Creates a scaling matrix and stores it in a target matrix
			 * @param x defines the x coordinate of the scaling
			 * @param y defines the y coordinate of the scaling
			 * @param result defines the target matrix
			 */
			Matrix2D.ScalingToRef = function (x, y, result) {
				result.fromValues(x, 0, 0, y, 0, 0);
			};
			/**
			 * Creates a rotation matrix and stores it in a target matrix
			 * @param angle defines the rotation angle
			 * @param result defines the target matrix
			 */
			Matrix2D.RotationToRef = function (angle, result) {
				var s = Math.sin(angle);
				var c = Math.cos(angle);
				result.fromValues(c, s, -s, c, 0, 0);
			};
			/**
			 * Composes a matrix from translation, rotation, scaling and parent matrix and stores it in a target matrix
			 * @param tx defines the x coordinate of the translation
			 * @param ty defines the y coordinate of the translation
			 * @param angle defines the rotation angle
			 * @param scaleX defines the x coordinate of the scaling
			 * @param scaleY defines the y coordinate of the scaling
			 * @param parentMatrix defines the parent matrix to multiply by (can be null)
			 * @param result defines the target matrix
			 */
			Matrix2D.ComposeToRef = function (tx, ty, angle, scaleX, scaleY, parentMatrix, result) {
				Matrix2D.TranslationToRef(tx, ty, Matrix2D._TempPreTranslationMatrix);
				Matrix2D.ScalingToRef(scaleX, scaleY, Matrix2D._TempScalingMatrix);
				Matrix2D.RotationToRef(angle, Matrix2D._TempRotationMatrix);
				Matrix2D.TranslationToRef(-tx, -ty, Matrix2D._TempPostTranslationMatrix);
				Matrix2D._TempPreTranslationMatrix.multiplyToRef(Matrix2D._TempScalingMatrix, Matrix2D._TempCompose0);
				Matrix2D._TempCompose0.multiplyToRef(Matrix2D._TempRotationMatrix, Matrix2D._TempCompose1);
				if (parentMatrix) {
					Matrix2D._TempCompose1.multiplyToRef(Matrix2D._TempPostTranslationMatrix, Matrix2D._TempCompose2);
					Matrix2D._TempCompose2.multiplyToRef(parentMatrix, result);
				}
				else {
					Matrix2D._TempCompose1.multiplyToRef(Matrix2D._TempPostTranslationMatrix, result);
				}
			};
			Matrix2D._TempPreTranslationMatrix = Matrix2D.Identity();
			Matrix2D._TempPostTranslationMatrix = Matrix2D.Identity();
			Matrix2D._TempRotationMatrix = Matrix2D.Identity();
			Matrix2D._TempScalingMatrix = Matrix2D.Identity();
			Matrix2D._TempCompose0 = Matrix2D.Identity();
			Matrix2D._TempCompose1 = Matrix2D.Identity();
			Matrix2D._TempCompose2 = Matrix2D.Identity();
			return Matrix2D;
		}());
	}
};

const AccessorComponentType = {
    BYTE: 5120,
    UNSIGNED_BYTE: 5121,
    SHORT: 5122,
    UNSIGNED_SHORT: 5123,
    UNSIGNED_INT: 5125,
    FLOAT: 5126,
};

function _NormalizeTangentFromRef(tangent) {
    const length = Math.sqrt(tangent.x * tangent.x + tangent.y * tangent.y + tangent.z * tangent.z);
    if (length > 0) {
        tangent.x /= length;
        tangent.y /= length;
        tangent.z /= length;
    }
}

export function _writeAttributeData (
        vertexBufferKind,
        attributeComponentKind,
        meshAttributeArray,
        stride,
        binaryWriter,
        convertToRightHandedSystem,
        babylonTransformNode
    )
{
	let vertexAttributes = [];
	let index;

	let writeBinaryFunc;
	switch (attributeComponentKind) {
		case AccessorComponentType.UNSIGNED_BYTE: {
			writeBinaryFunc = binaryWriter.setUInt8.bind(binaryWriter);
			break;
		}
		case AccessorComponentType.UNSIGNED_SHORT: {
			writeBinaryFunc = binaryWriter.setUInt16.bind(binaryWriter);
			break;
		}
		case AccessorComponentType.UNSIGNED_INT: {
			writeBinaryFunc = binaryWriter.setUInt32.bind(binaryWriter);
			break;
		}
		case AccessorComponentType.FLOAT: {
			writeBinaryFunc = binaryWriter.setFloat32.bind(binaryWriter);
			break;
		}
		default: {
			console.warn("Unsupported Attribute Component kind: " + attributeComponentKind);
			return;
		}
	}

	switch (vertexBufferKind) {
        case BABYLON.VertexBuffer.NormalKind:
		case BABYLON.VertexBuffer.PositionKind: {
            if (convertToRightHandedSystem) {
                for(let index = 0; index < meshAttributeArray.length; index += stride)
                    binaryWriter.setFloat32FromValues(meshAttributeArray[index], meshAttributeArray[index + 1], -meshAttributeArray[index + 2]);
            }
            else
			{
			    for(let index = 0; index < meshAttributeArray.length; index += stride)
                    binaryWriter.setFloat32FromValues(meshAttributeArray[index], meshAttributeArray[index + 1], meshAttributeArray[index + 2]);
			}
			break;
		}
		case BABYLON.VertexBuffer.TangentKind: {
			for (let k = 0, length = meshAttributeArray.length / stride; k < length; ++k) {
				index = k * stride;
				const vertexData = Vector4.FromArray(meshAttributeArray, index);
				if (convertToRightHandedSystem) {
                    vector.z *= -1;
                    vector.w *= -1;
				}
				_NormalizeTangentFromRef(vertexData);

				vertexAttributes.push(vertexData.asArray());
			}
			break;
		}
		case BABYLON.VertexBuffer.ColorKind: {
			const meshMaterial = babylonTransformNode.material;
			const convertToLinear = meshMaterial ? meshMaterial.getClassName() === "StandardMaterial" : true;
			const vertexData = stride === 3 ? new BABYLON.Color3() : new BABYLON.Color4();
			const useExactSrgbConversions = this._babylonScene.getEngine().useExactSrgbConversions;
			for (let k = 0, length = meshAttributeArray.length / stride; k < length; ++k) {
				index = k * stride;
				if (stride === 3) {
					Color3.FromArrayToRef(meshAttributeArray, index, vertexData);
					if (convertToLinear) {
						vertexData.toLinearSpaceToRef(vertexData, useExactSrgbConversions);
					}
				} else {
					Color4.FromArrayToRef(meshAttributeArray, index, vertexData);
					if (convertToLinear) {
						vertexData.toLinearSpaceToRef(vertexData, useExactSrgbConversions);
					}
				}
				vertexAttributes.push(vertexData.asArray());
			}
			break;
		}
		case BABYLON.VertexBuffer.UVKind:
		case BABYLON.VertexBuffer.UV2Kind: {
			for (let k = 0, length = meshAttributeArray.length / stride; k < length; ++k) {
				index = k * stride;
                binaryWriter.setFloat32(meshAttributeArray[index]);
                binaryWriter.setFloat32(meshAttributeArray[index + 1]);
			}
			break;
		}
		case BABYLON.VertexBuffer.MatricesIndicesKind:
		case BABYLON.VertexBuffer.MatricesIndicesExtraKind: {
			for (let k = 0, length = meshAttributeArray.length / stride; k < length; ++k) {
				index = k * stride;
				const vertexData = Vector4.FromArray(meshAttributeArray, index);
				vertexAttributes.push(vertexData.asArray());
			}
			break;
		}
		case BABYLON.VertexBuffer.MatricesWeightsKind:
		case BABYLON.VertexBuffer.MatricesWeightsExtraKind: {
			for (let k = 0, length = meshAttributeArray.length / stride; k < length; ++k) {
				index = k * stride;
				const vertexData = Vector4.FromArray(meshAttributeArray, index);
				vertexAttributes.push(vertexData.asArray());
			}
			break;
		}
		default: {
			Tools.Warn("Unsupported Vertex Buffer Type: " + vertexBufferKind);
			vertexAttributes = [];
		}
	}

	for (const vertexAttribute of vertexAttributes) {
		for (const component of vertexAttribute) {
			writeBinaryFunc(component);
		}
	}
};

export function _CalculateMinMaxPositions (positions, vertexStart, vertexCount, convertToRightHandedSystem) {
    var min = [Infinity, Infinity, Infinity];
    var max = [-Infinity, -Infinity, -Infinity];
    const positionStrideSize = 3;
    var indexOffset;
    if(vertexCount <= 0)
        return { min: min, max: max };
    
    var j, num;
    for (var i = vertexStart, length_1 = vertexStart + vertexCount; i < length_1; ++i) {
        indexOffset = positionStrideSize * i;
        for (j = 0; j < positionStrideSize; ++j) {           
            num = positions[indexOffset + j];
            if(convertToRightHandedSystem && j === 2);
                num *= -1;

            if (num < min[j]) {
                min[j] = num;
            }
            else if (num > max[j]) {
                max[j] = num;
            }
            ++indexOffset;
        }
    }
    
    return { min: min, max: max };
};

function patchGLTFExporter()
{
    // Perf optimization overrides
    const INIT_BUFFER_SIZE_MB = 128;
    function betterBinaryAsyncGen() {
	    const binaryWriter = new _BinaryWriter(1024*1024*INIT_BUFFER_SIZE_MB);
	    return this._createSceneAsync(this._babylonScene, binaryWriter).then(() => {
		    if(this._localEngine)
			    this._localEngine.dispose();
		    return binaryWriter.getArrayBuffer();
	    });
    };
    _Exporter.prototype._generateBinaryAsync = betterBinaryAsyncGen;
    _Exporter.prototype._writeAttributeData = _writeAttributeData;
    _BinaryWriter.prototype.setFloat32FromValues = function (v1, v2, v3) {
        if(this._byteOffset + 12 > this._arrayBuffer.byteLength)
	        this._resizeBuffer(this._arrayBuffer.byteLength*2);

        this._dataView.setFloat32(this._byteOffset, v1, true);
        this._dataView.setFloat32(this._byteOffset + 4, v2, true);
        this._dataView.setFloat32(this._byteOffset + 8, v3, true);
        this._byteOffset += 4*3;
    };

    _GLTFUtilities._CalculateMinMaxPositions = _CalculateMinMaxPositions;
}

let meshIntersectWorldOrigin = BABYLON.Vector3.Zero();
let meshIntersectWorldDir = BABYLON.Vector3.Zero();
let faceLocalVerts = [BABYLON.Vector3.Zero(), BABYLON.Vector3.Zero(), BABYLON.Vector3.Zero()];
function patchMeshIntersection()
{
    if(!BABYLON.AbstractMesh.prototype.oldMeshIntersect)
        BABYLON.AbstractMesh.prototype.oldMeshIntersect = BABYLON.AbstractMesh.prototype.intersects;

    BABYLON.Mesh.prototype.intersects = function (ray, fastCheck, trianglePredicate, onlyBoundingInfo, worldToUse, skipBoundingInfo) {
        if(!this.localVoxelGrid)
            return this.oldMeshIntersect(ray, fastCheck, trianglePredicate, onlyBoundingInfo, worldToUse, skipBoundingInfo);

        let resInfo = new BABYLON.PickingInfo();

        // Boudning info test first
        let boundingInfo = this.getBoundingInfo();
        if(!this.subMeshes)
            return resInfo;

        if(!ray.intersectsSphere(boundingInfo.boundingSphere, 0) || !ray.intersectsBox(boundingInfo.boundingBox, 0))
            return resInfo;

		let positions = this.getVerticesData(BABYLON.VertexBuffer.PositionKind);
		let indices = this.getIndices();

        // Otherwise, do our own:
        let faceInfos = this.localVoxelGrid.getObjectsForRay(ray.origin, ray.direction);
        let fClosestDist = Number.MAX_VALUE;
        let closestIntersectInfo = null;
        for(let faceInfo of faceInfos)
		{
            for(let pointIdx = 0; pointIdx < 3; pointIdx++)
            {
                let pointIndex = indices[faceInfo.index + pointIdx];
                faceLocalVerts[pointIdx].copyFromFloats(positions[pointIndex*3], positions[pointIndex*3 + 1], positions[pointIndex*3 + 2]);
            }
            let intersectInfo = ray.intersectsTriangle(faceLocalVerts[0], faceLocalVerts[1], faceLocalVerts[2]);
            if(!intersectInfo || intersectInfo.distance < 0)
                continue;

			if(intersectInfo.distance < fClosestDist)
			{
				fClosestDist = intersectInfo.distance;
                closestIntersectInfo = intersectInfo;
			}
		}
       
        if(closestIntersectInfo)
		{
            let world = worldToUse !== null && worldToUse !== void 0 ? worldToUse : this.getWorldMatrix();
            BABYLON.Vector3.TransformCoordinatesToRef(ray.origin, world, meshIntersectWorldOrigin);
            ray.direction.scaleToRef(fClosestDist, meshIntersectWorldDir);
            let worldDirection = BABYLON.Vector3.TransformNormal(meshIntersectWorldDir, world);
            let pickedPoint = worldDirection.addInPlace(meshIntersectWorldOrigin);

            resInfo.hit = true;
            resInfo.distance = fClosestDist;
            resInfo.pickedPoint = pickedPoint;

            resInfo.pickedMesh = this;
            resInfo.bu = closestIntersectInfo.bu || 0;
            resInfo.bv = closestIntersectInfo.bv || 0;
		}
      
        return resInfo;
    };
}